export const SIZE = {
  SIZE: 25,
  SIZE_17: 17,
  SIZE_20: 20,
};
